import { FlagsManager } from '@databases/flags';

import { DatabaseContentIdChanged } from '../events/database-content-id-changed';
import { EventListener } from '../types';

export class ClearFlagsFromFlagsManager
  implements EventListener<DatabaseContentIdChanged>
{
  constructor(private readonly flagsManager: FlagsManager) {}

  handle(): void {
    this.flagsManager.clearFlags();
  }
}
